// extracted by mini-css-extract-plugin
export default {"card":"FeatureCard_card__x82oM","avatar":"FeatureCard_avatar__BszgM","button":"FeatureCard_button__dbrQ1"};